import { FormEvent, useState } from "react"
import { router } from "@inertiajs/react"
import { Box, Button, Stack, TextField, Typography } from "@mui/material"
import FileField from "../../../components/FileField"

type TopicForm = {
  id: number | null
  name: string
  summary: string | null
  jp: string | null
  slug: string | null
  banner_url: string | null
}

type Props = {
  topic: TopicForm
  errors?: Record<string, string[]>
}

export default function TopicForm({ topic, errors }: Props) {
  const isNew = !topic.id
  const [name, setName] = useState(topic.name ?? "")
  const [summary, setSummary] = useState(topic.summary ?? "")
  const [jp, setJp] = useState(topic.jp ?? "")
  const [banner, setBanner] = useState<File | null>(null)

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    const data = new FormData()
    data.append("topic[name]", name)
    data.append("topic[summary]", summary)
    data.append("topic[jp]", jp)
    if (banner) data.append("topic[banner]", banner)

    const url = isNew ? "/admin/topics" : `/admin/topics/${topic.slug}`
    if (isNew) {
      router.post(url, data, { forceFormData: true })
    } else {
      data.append("_method", "patch")
      router.post(url, data, { forceFormData: true })
    }
  }

  return (
    <Box component="form" onSubmit={onSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h5">{isNew ? "New topic" : `Edit ${topic.name}`}</Typography>
      <TextField
        label="Name" required value={name} onChange={(e) => setName(e.target.value)}
        slotProps={{ htmlInput: { "data-testid": "topic-name" } }}
        error={!!errors?.name} helperText={errors?.name?.join(", ")}
      />
      <TextField
        label="Japanese (jp)" value={jp} onChange={(e) => setJp(e.target.value)}
        slotProps={{ htmlInput: { "data-testid": "topic-jp" } }}
      />
      <TextField
        label="Summary" value={summary} onChange={(e) => setSummary(e.target.value)} multiline rows={3}
        slotProps={{ htmlInput: { "data-testid": "topic-summary" } }}
      />
      <FileField label="Banner image" accept="image/*" name="banner"
                 onSelect={setBanner} selectedName={banner?.name ?? null}
                 existingUrl={topic.banner_url} testId="topic-banner" />
      <Stack direction="row" gap={2}>
        <Button type="submit" variant="contained" data-testid="topic-submit">
          {isNew ? "Create" : "Save changes"}
        </Button>
        <Button onClick={() => history.back()}>Cancel</Button>
      </Stack>
    </Box>
  )
}
